import type { EmailDraft } from '@/gen/cortado/v1/emails_pb'
import { ParentTypeEnum } from '@/gen/cortado/v1/settings_pb'
import type { EmailTemplateCategory } from './email-template-insert-menu'

export type EmailComposeTemplateContext =
  | 'general'
  | 'inquiry'
  | 'booking'
  | 'quote'
  | 'invoice'

interface EmailComposeSheetBaseProps {
  organizationId: string
  parentType: ParentTypeEnum
  parentId: string
  inquiryId?: string
  contactId?: string
  /** Seeds editable compose recipients; replies display it read-only. */
  toEmail: string
  templateContext?: EmailComposeTemplateContext
  open: boolean
  onOpenChange: (open: boolean) => void
}

interface EmailReplySheetProps extends EmailComposeSheetBaseProps {
  mode: 'reply'
  threadId: string
  /** The connected mailbox the thread came in on, shown under the picker. */
  cameInOnEmail?: string
  currentUserDraft?: EmailDraft
  existingThreadSubject?: string
  initialComposeDraft?: never
}

interface NewEmailSheetProps extends EmailComposeSheetBaseProps {
  mode: 'compose'
  threadId?: never
  cameInOnEmail?: never
  currentUserDraft?: never
  existingThreadSubject?: never
  initialComposeDraft?: EmailDraft
}

/** Mode is the discriminator, so reply-only and compose-only props cannot mix. */
export type EmailComposeSheetProps = EmailReplySheetProps | NewEmailSheetProps

export function getTemplateCategory(
  context?: EmailComposeTemplateContext,
): EmailTemplateCategory {
  switch (context) {
    case 'inquiry':
      return 'Inquiry'
    case 'booking':
      return 'Booking'
    case 'quote':
      return 'Quote'
    case 'invoice':
      return 'Invoice'
    case 'general':
    default:
      return 'General'
  }
}
